import { useEffect, useRef, useState } from "react";
import OverviewComponent from "../../../../shared/components/overview-panel/OverviewComponent";
import OverviewTabContent from "../../../../shared/components/overview-panel/OverviewTabContent";
import ToolsOverviewTable from "./ToolsOverviewTable";
import { catchFunction } from "../../../../shared/lib/utils";
import SearchInput from "../../../../shared/components/input/SearchInput";
import { useTracking } from "react-tracking";
import { SECTIONS as API_SECTIONS } from "../../../../shared/lib/apiEndpointsResolver";
import useAxios from "../../../../hooks/useAxios";
import useSectionSorting from "../shared/useSectionSorting";
import { useTranslation } from "react-i18next";

const ToolsOverview = () => {
  const axios = useAxios();
  const [tools, setTools] = useState([]);
  const toolsRef = useRef([]);
  const { trackEvent } = useTracking();
  const sectionSorting = useSectionSorting();
  const { t } = useTranslation();

  const breadcrumbItems = [{ title: "tools.overview.breadcrumb.first" }];

  const findTools = () => {
    axios
      .get(API_SECTIONS, { params: { category: "tools" } })
      .then((response) => {
        const sortedData = response.data.sort(sectionSorting);
        setTools(sortedData);
        toolsRef.current = sortedData;
      })
      .catch(catchFunction);
  };

  const filterToolsByTitle = (changeEvent) => {
    setTools(
      toolsRef.current.filter((tool) =>
        t(tool.title)
          .toLowerCase()
          .includes(changeEvent.target.value.toLowerCase()),
      ),
    );
  };

  const SearchInputComponent = (
    <SearchInput
      onChangeHandler={filterToolsByTitle}
      placeholder="tools.overview.searchInputPlaceholder"
    />
  );

  const toolsTabs = [
    {
      trigger: { value: "all", label: "tools.overview.tabs.trigger.all" },
      content: (
        <OverviewTabContent
          value="all"
          title="tools.overview.card.all.title"
          description="tools.overview.card.all.description"
        >
          <ToolsOverviewTable data={tools} />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "adq",
        label: "tools.overview.tabs.trigger.adq",
      },
      content: (
        <OverviewTabContent
          value="adq"
          title="tools.overview.card.adq.title"
          description="tools.overview.card.adq.description"
        >
          <ToolsOverviewTable
            data={tools.filter((x) => x.type.code === "adq")}
          />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "powerbi",
        label: "tools.overview.tabs.trigger.powerbi",
      },
      content: (
        <OverviewTabContent
          value="powerbi"
          title="tools.overview.card.powerbi.title"
          description="tools.overview.card.powerbi.description"
        >
          <ToolsOverviewTable
            data={tools.filter((x) => x.type.code === "powerbi")}
          />
        </OverviewTabContent>
      ),
    },
    {
      trigger: { value: "gdrive", label: "tools.overview.tabs.trigger.gdrive" },
      content: (
        <OverviewTabContent
          value="gdrive"
          title="tools.overview.card.gdrive.title"
          description="tools.overview.card.gdrive.description"
        >
          <ToolsOverviewTable
            data={tools.filter((x) => x.type.code === "gdrive")}
          />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "lstudio",
        label: "tools.overview.tabs.trigger.lstudio",
      },
      content: (
        <OverviewTabContent
          value="lstudio"
          title="tools.overview.card.lstudio.title"
          description="tools.overview.card.lstudio.description"
        >
          <ToolsOverviewTable
            data={tools.filter((x) => x.type.code === "lstudio")}
          />
        </OverviewTabContent>
      ),
    },
  ];

  useEffect(() => {
    findTools();
    trackEvent({
      page: "tools-overview",
      event: "page-load",
    });
  }, []);

  return (
    <OverviewComponent
      breadcrumbItems={breadcrumbItems}
      options={SearchInputComponent}
      tabs={toolsTabs}
    />
  );
};

export default ToolsOverview;
